<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('triggers') }} -> {{ $t('create-trigger-mailing') }}
    </h1>
    <div class="main__body">
      <p class="gray-about">{{ $t('create-trigger-mailing-about-1') }}</p>
      <div class="row">
        <div class="form-block">
          <div class="form-group">
            <label>{{ $t('name-mailing') }}</label>
            <input class="large" type="text" :placeholder="$t('name-mailing')" v-model="trigger.name">
            <span class="error" v-if="errors.name">{{ errors.name[0] }}</span>
          </div>
        </div>
        <div class="form-block">
          <div class="form-group">
            <label>{{ $t('trigger-triggered') }}</label>
            <select class="custom-select large" v-model="trigger.trigger_id">
              <option v-for="item in triggers" v-bind:key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
            <span class="error" v-if="errors.trigger_id">{{ errors.trigger_id[0] }}</span>
          </div>
          <div class="trigger__item">
            <div class="trigger__item-left">
              <label>{{ $t('action') }}</label>
              <div class="trigger__item-text">
                {{ $t('message') }} {{ $t('for') }} telegram <img src="@/assets/social/telegram.svg">
              </div>
            </div>
            <div class="trigger__item-right">
              <label>{{ $t('mailing') }}</label>
              <div class="trigger__item-body-data">
                <textarea class="small" :placeholder="$t('size-for-message')" v-model="trigger.msg_telegram"></textarea>
              </div>
            </div>
          </div>
          <div class="trigger__item">
            <div class="trigger__item-left">
              <label>{{ $t('action') }}</label>
              <div class="trigger__item-text">
                {{ $t('message') }} {{ $t('for') }} viber <img src="@/assets/social/viber.svg">
              </div>
            </div>
            <div class="trigger__item-right">
              <label>{{ $t('mailing') }}</label>
              <div class="trigger__item-body-data">
                <textarea class="small" :placeholder="$t('size-for-message')" v-model="trigger.msg_viber"></textarea>
              </div>
            </div>
          </div>
          <div class="trigger__item">
            <div class="trigger__item-left">
              <label>{{ $t('action') }}</label>
              <div class="trigger__item-text">
                {{ $t('message') }} {{ $t('for') }} sms <img src="@/assets/social/sms.svg">
              </div>
            </div>
            <div class="trigger__item-right">
              <label>{{ $t('mailing') }}</label>
              <div class="trigger__item-body-data">
                <textarea class="small" :placeholder="$t('max-length-sms')" v-model="trigger.msg_sms"></textarea>
              </div>
            </div>
          </div>
          <div class="trigger__item">
            <div class="trigger__item-left">
              <label>{{ $t('action') }}</label>
              <div class="trigger__item-text">
                {{ $t('message') }} {{ $t('for') }} email <img src="@/assets/social/email.svg">
              </div>
            </div>
            <div class="trigger__item-right">
              <label>{{ $t('mailing') }}</label>
              <div class="trigger__item-body-data">
                <a class="link-blue like__text-area" @click="showUploadFileModal">{{ $t('upload-email-html-format') }}</a>
              </div>
            </div>
          </div>
          <div class="form-row mt-4">
            <a class="btn btn-primary" @click="createTriggerMailing">{{ $t('create-trigger-mailing') }}</a>
          </div>
        </div>
      </div>
    </div>
    <upload-file-modal v-show="isModalUploadFileVisible"
                       @close="closeUploadFileModal"/>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>


<style scoped>

a.btn{
  width: 308px;
  height: 49px;
  padding: 14px 0 !important;
}

a.like__text-area{
  height: 120px !important;
}

.trigger__item{
  display: flex;
  justify-content: flex-start;
  position: relative;
  margin-top: 15px;
}

.trigger__item-left{
  position: absolute;
  left: -250px;
  display: flex;
  flex-direction: column;
}

.trigger__item-left label, .trigger__item .trigger__item-right label{
  font-size: 14px;
  color: #606F89;
}

.trigger__item-left .trigger__item-text{
  font-weight: bold;
  font-size: 14px;
  color: #484848;
  margin-top: 20px;
}

.trigger__item-right .trigger__item-body-data{
  margin-top: 20px;
}

</style>

<script>
import axios from 'axios'
import loading from "vue-loading-overlay";
import uploadFileModal from "../components/modal/uploadFIleModal";

export default {
  name: 'createTrigger',
  data: function () {
    return {
      trigger: {
        name: '',
        msg_telegram: '',
        msg_viber: '',
        msg_sms: '',
        msg_email: '',
        trigger_id: 0,
      },
      triggers: [],
      errors: [],
      isModalUploadFileVisible: false,
      isLoading: false,
      fullPage: true,
    }
  },
  watch: {
    isModalUploadFileVisible: function () {
      var $this = this;
      this.$root.$on('file', function(val){
        $this.uploadFile(val);
      });
    },
  },
  created: function () {
    this.getTriggers();
  },
  methods: {
    uploadFile: function(file){
      console.log(file)
      const reader = new FileReader();
      reader.addEventListener('load', event => {
        this.trigger.msg_email = event.target.result;
      });
      reader.readAsText(file);
    },
    createTriggerMailing: function () {
      axios.post('createTriggerMailing', this.trigger).then(response => {
        var status = response.data.status;
        if (status) {
          this.trigger.name = null;
          this.trigger.msg_telegram = null;
          this.trigger.msg_viber = null;
          this.trigger.msg_sms = null;
          this.trigger.msg_email = null;
          this.errors = [];
          this.$toast.success("Триггерная рассылка успешно создана");
        } else {
          this.errors = response.data.errors;
        }
      });
    },
    getTriggers: function () {
      this.isLoading = true;
      axios.post('getTriggers', this.$store.getters.user).then(response => {
        var status = response.data.status;
        if (status) {
          this.triggers = response.data.triggers;
          if (this.triggers.length > 0) {
            this.trigger.trigger_id = this.triggers[0].id;
          }
          this.isLoading = false;
        }
      });
    },
    showUploadFileModal() {
      this.isModalUploadFileVisible = true;
    },
    closeUploadFileModal() {
      this.isModalUploadFileVisible = false;
    },
  },
  components: {
    loading, uploadFileModal
  }
}
</script>